import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { Company, Office } from '../models/office.model';

@Pipe({
  name: 'office'
})
@Injectable({
  providedIn: 'root'
})
export class OfficePipe implements PipeTransform {

  transform(id: number, companies: Company[]): Office {
    const offices: Office[] = [];

    companies.map(company => company.offices?.forEach(office => {
      offices.push(office);
    }));

    return offices.find(office => id === office.id);
  }

}
